<template>
  <div class="layout">
    <!-- 页面内容区 -->
    <div class="page-content">
      <router-view />
    </div>
  </div>
</template>

<script>
export default {
  name: 'activityLayout',
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/menu/activityLayout.vue